import { Stack } from "@mui/material";
import { DotSeparatedList, Title } from "@src/appV2/redesign/system/ui-components";

import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { readableVisitTypeMapping } from "../constants";

export function VisitBottomSheetHeader() {
  const { visit } = useInHomeVisitModalsDataContext();
  if (!visit) {
    return null;
  }

  return (
    <Stack
      alignItems="space-between"
      sx={(theme) => ({
        paddingTop: 6,
        paddingBottom: 7,
        px: 7,
        transition: theme.transitions.create(["background"]),
        background: theme.palette.homeHealth?.visit.gradient,
      })}
      spacing={4}
    >
      <PageHeaderTopRow sx={{ px: 0 }} />
      <Stack justifyContent="space-between" alignItems="flex-start" spacing={4}>
        <DotSeparatedList>
          <Title component="h3" variant="h3" sx={{ wordBreak: "break-word" }}>
            {readableVisitTypeMapping[visit.attributes.type] ?? visit.attributes.type}
          </Title>
          <Title component="h3" variant="h3" sx={{ wordBreak: "break-word" }}>
            {visit.attributes.workerReq}
          </Title>
        </DotSeparatedList>
      </Stack>
    </Stack>
  );
}
